import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.input.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
    },
    label: {
      fontSize: 16,
      fontWeight: 500,
      textAlign: "center",
      color: theme.text.secondary,
    },
    counterContainer: {
      justifyContent: "space-between",
      alignItems: "center",
      marginLeft: spacing.xs,
      marginRight: spacing.xs,
    },
    circle: {
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    circleDisabled: {
      opacity: 0.3,
      cursor: "default",
    },
    amount: {
      userSelect: "none",
    },
  };

  return styles;
};
